/**
 * LENIDESIGN — AJAX Add to Cart
 * Intercepte les forms leniStdForm et leniProductForm
 * et ouvre le cart drawer après ajout au panier
 */
(function() {
  'use strict';

  var FORM_IDS = ['leniStdForm', 'leniProductForm'];

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function openCartDrawer() {
    var drawer = getCartDrawer();
    if (drawer && typeof drawer.open === 'function') {
      var trigger = document.querySelector('#cart-icon-bubble');
      drawer.open(trigger);
    }
  }

  function updateCartDrawerContents() {
    // Demande à Dawn de re-rendre le contenu du cart drawer
    return fetch(window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root + '?section_id=cart-drawer'
      : '/?section_id=cart-drawer')
      .then(function(res) { return res.text(); })
      .then(function(text) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(text, 'text/html');
        var newDrawer = doc.querySelector('#CartDrawer');
        var currentDrawer = document.querySelector('#CartDrawer');
        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
        }
        // Mettre à jour le compteur panier dans le header
        var newCount = doc.querySelector('.cart-count-bubble');
        var currentCount = document.querySelector('.cart-count-bubble');
        if (newCount && currentCount) {
          currentCount.innerHTML = newCount.innerHTML;
        }
        // Mettre à jour notre compteur custom
        return fetch('/cart.js');
      })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var count = cart.item_count;
        var cartCountEl = document.querySelector('.leni-header__cart-count');
        if (cartCountEl) {
          cartCountEl.textContent = count;
          cartCountEl.style.display = count > 0 ? 'flex' : 'none';
        }
      })
      .catch(function(err) {
        // Fallback : recharger si tout échoue
        console.error('[Lenidesign] Cart update failed:', err);
      });
  }

  function setButtonLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.setAttribute('disabled', 'disabled');
      btn.dataset.originalText = btn.textContent;
      btn.textContent = 'Ajout en cours...';
    } else {
      btn.removeAttribute('disabled');
      btn.textContent = btn.dataset.originalText || 'Ajouter au panier';
    }
  }

  function handleFormSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    var form = e.currentTarget;
    var btn = form.querySelector('[type="submit"]');
    setButtonLoading(btn, true);

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
    .then(function(res) {
      if (!res.ok) {
        return res.json().then(function(data) {
          throw new Error(data.description || 'Erreur ajout panier');
        });
      }
      return res.json();
    })
    .then(function() {
      setButtonLoading(btn, false);
      // Mettre à jour le contenu puis ouvrir le drawer
      return updateCartDrawerContents();
    })
    .then(function() {
      openCartDrawer();
    })
    .catch(function(err) {
      setButtonLoading(btn, false);
      // Afficher l'erreur sous le bouton
      var errEl = form.querySelector('.leni-atc-error');
      if (!errEl) {
        errEl = document.createElement('p');
        errEl.className = 'leni-atc-error';
        errEl.style.cssText = 'color:#E63946;font-size:13px;margin-top:8px;';
        btn.insertAdjacentElement('afterend', errEl);
      }
      errEl.textContent = err.message || 'Erreur lors de l\'ajout au panier.';
    });
  }

  function attachForms() {
    FORM_IDS.forEach(function(id) {
      var form = document.getElementById(id);
      if (form && !form.dataset.leniAtcBound) {
        form.addEventListener('submit', handleFormSubmit);
        form.dataset.leniAtcBound = 'true';
      }
    });
  }

  // Attacher au load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachForms);
  } else {
    attachForms();
  }

  // Re-attacher si le DOM change (variantes Shopify re-render)
  var observer = new MutationObserver(function() {
    attachForms();
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();
